(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/device-services/assets/javascripts/native/native-bridge.js') >= 0) return;  svs.modules.push('/components/tur/device-services/assets/javascripts/native/native-bridge.js');

'use strict';

const shakeCallbacks = new Set();
const motionCallbacks = new Set();
function ensureShakeHandler() {
  if (typeof window === 'undefined') {
    return;
  }
  if (!window.incrementShakeCount) {
    window.incrementShakeCount = () => {
      shakeCallbacks.forEach(cb => {
        try {
          cb();
        } catch (e) {
        }
      });
    };
  }
  if (window.onDeviceShakeGesture) {
    return;
  }
  window.onDeviceShakeGesture = () => {
    shakeCallbacks.forEach(cb => {
      try {
        cb();
      } catch (e) {
      }
    });
  };
}
function ensureMotionHandler() {
  if (typeof window === 'undefined') {
    return;
  }
  if (window.updateDeviceMotionData) {
    return;
  }
  window.updateDeviceMotionData = data => {
    motionCallbacks.forEach(cb => {
      try {
        cb(data);
      } catch (e) {}
    });
  };
}

function subscribeToShakeEvent(cb) {
  ensureShakeHandler();
  shakeCallbacks.add(cb);
  return () => {
    shakeCallbacks.delete(cb);
  };
}

function subscribeToMotionEvent(cb) {
  ensureMotionHandler();
  motionCallbacks.add(cb);
  return () => {
    motionCallbacks.delete(cb);
  };
}

function postMessage(handlerName, payload) {
  var _window$webkit;
  (_window$webkit = window.webkit) === null || _window$webkit === void 0 || (_window$webkit = _window$webkit.messageHandlers) === null || _window$webkit === void 0 || (_window$webkit = _window$webkit[handlerName]) === null || _window$webkit === void 0 || _window$webkit.postMessage(payload);
}

function isSupported() {
  var _window$webkit2;
  if (typeof window === 'undefined') {
    return false;
  }
  return Boolean((_window$webkit2 = window.webkit) === null || _window$webkit2 === void 0 ? void 0 : _window$webkit2.messageHandlers);
}
setGlobal('svs.tur.device.nativeBridge', {
  subscribeToShakeEvent,
  subscribeToMotionEvent,
  postMessage,
  isSupported
});

 })(window);